import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { AccountantUpdateDto } from '../../_dto/_accountant/AccountantWorkerDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiUpdateAccountant = async (dto: AccountantUpdateDto) => {
  const params: IApiParams = {
    url: '/accountant/updateAccountant.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'PUT', dto);
};
